module.exports = __webpack_public_path__ + "img/woobang.acee0ae0.svg";